import { Button } from "common/components/ui/Button";
import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useLicenseMutations from "common/datahooks/useLicenseMutations";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface RemoveLicenseProps {
  accountId: string;
  accountFullname: string;
  goBack: () => void;
  onSuccess: () => void;
}

export default function RemoveLicense({
  accountId,
  accountFullname,
  goBack,
  onSuccess,
}: RemoveLicenseProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { removeLicense, isRemovingLicense } = useLicenseMutations();

  function onRemove() {
    removeLicense({ accountId }).then(onSuccess);
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>Unassign seat from "{accountFullname}"?</Title>
      <Description className="mb-8">
        This will stop all campaigns on this LinkedIn account. You can re-assign
        this seat at any time
      </Description>

      <div className="flex gap-x-2.5 justify-between">
        <Button
          onClick={goBack}
          variant="secondary-black"
          disabled={isRemovingLicense}
          className="lg:flex-1"
        >
          Cancel
        </Button>
        <Button
          isLoading={isRemovingLicense}
          onClick={onRemove}
          variant="outline-danger"
          className="lg:flex-1"
        >
          Unassign
        </Button>
      </div>
    </>
  );
}
